import { current } from "@reduxjs/toolkit";
import { useState, useRef, useEffect, use } from "react";

export default function TipSelector({ options, optionType, onTipSelect }) {
  const [selected, setSelected] = useState("0");
  const inputRef = useRef(null);
  useEffect(() => {
    if (selected === "custom" && inputRef.current) {
      inputRef.current.focus();
    }
  }, [selected]);

  return (
    <div className="flex rounded-full overflow-hidden md:border-[5px] border-[2px] border-bordergray bg-[#fafafa]">
      {options.map((opt, idx) => (
        <div key={opt} className="flex-1">
          {selected === "custom" && opt === "custom" ? (
            <div className="flex items-center justify-center md:py-4 py-2 bg-boonsOrange text-textcolor">
              <span className=" md:text-[30px] text-[15px] font-outfit font-medium text-white pl-3">$</span>
              <input
                ref={inputRef}
                type="number"
                min="0"
                className="md:w-24 w-16 pl-1 bg-transparent outline-none md:text-[30px] text-[15px] font-outfit font-medium text-white placeholder-white"
                placeholder="0"
                onChange={(e) => onTipSelect({ value: parseFloat(e.target.value) || 0, type: 'amount' })}
              />
            </div>
          ) : (
            <button
              onClick={() => {
                setSelected(opt);
                onTipSelect(opt === "custom" ? { value: 0, type: 'amount' } : { value: parseFloat(opt), type: 'percent' });
              }}
              className={`md:text-[30px] text-[15px] w-full md:py-4 py-2 text-center font-outfit  font-medium border-bordergray transition-all
                ${opt !== "custom" ? "md:border-r-[5px] border-r-[3px]" : ""}
            ${selected === opt
                  ? "bg-boonsOrange text-white font-semibold"
                  : "bg-white text-textcolor"}`}
            >
              {opt === "custom" ? 'Custom' : opt === '0' ? "No tip" : `${opt}${optionType[idx]}`}
            </button>
          )}
        </div>
      ))}
    </div>

  );
}
